var map = {
	"./call.svg": 3058,
	"./email.svg": 3059,
	"./food.svg": 3060,
	"./house.svg": 3061,
	"./people.svg": 3062,
	"./task.svg": 3063,
	"./whatsapp.svg": 3064
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 630;